export default {
  methods: {
    getRoadNameToRoadNameShortMap() {
      // roadName -> roadNameShort
      return {
        '高速1号上野線': '上',
        '高速1号羽田線': '羽',
        '高速2号目黒線': '目',
        '高速3号渋谷線': '渋',
        '高速4号新宿線': '新',
        '高速5号池袋線（東京東地区）': '池',
        '高速5号池袋線（東京西地区）': '池',
        '高速6号三郷線': '三',
        '高速6号向島線': '向',
        '高速7号小松川線': '小',
        '高速9号深川線': '深',
        '高速10号晴海線': '晴',
        '高速11号台場線': '台',
        '高速中央環状線（東京東地区）': '中',
        '高速中央環状線（東京西地区）': '中',
        '高速八重洲線': '八',
        '高速埼玉大宮線': '大宮',
        '高速埼玉新都心線': '新都',
        '高速川口線': '川',
        '高速湾岸線（東京地区）': '湾',
        '高速湾岸線（神奈川地区）': '湾',
        '高速神奈川1号横羽線': '横',
        '高速神奈川2号三ツ沢線': '三ツ沢',
        '高速神奈川3号狩場線': '狩',
        '高速神奈川5号大黒線': '大',
        '高速神奈川6号川崎線': '川崎',
        '高速神奈川7号横浜北線': '横北',
        '高速神奈川7号横浜北西線': '横北西',
        '高速都心環状線': '環',
      }
    },
    getRoadNameShortToRoadNameMap() {
      const obj = this.getRoadNameToRoadNameShortMap()
      const ret = {}
      Object.keys(obj).forEach(roadName => {
        const shortName = obj[roadName]
        if (!ret[shortName]) { ret[shortName] = [] }
        ret[shortName].push(roadName)
      })
      return ret
    },
    getRoadNameIgnoreMap() {
      // 既知の無視対象
      return {
        '9支': 1,
      }
    },
    getAltKpPrefixMap() {
      // ちょっと違う名前のやつ.
      const tmpMap = {}
      const roadNameShorts =
        Object.keys(this.getRoadNameShortToRoadNameMap())
      roadNameShorts.forEach(rns => {
        tmpMap[rns] = rns
      })
      tmpMap['浮'] = '湾' // 浮島
      tmpMap['大黒'] = '大' // 大黒
      tmpMap['大黒R'] = '大' // 大黒
      tmpMap['大師'] = '横' // 大師
      tmpMap['生'] = '横' // 生麦
      tmpMap['新横'] = '横北' // 新横浜
      tmpMap['港'] = '横北' // 港北(範囲外)
      tmpMap['舞'] = '湾' // 舞浜
      tmpMap['支'] = '湾' // なんかしらんが湾岸らしい

      const ret = {}
      Object.keys(tmpMap).forEach(k => {
        const val = tmpMap[k]
        ret[k] = val
        // x支、x支内、x支外
        ret[`${k}支`] = val
        ret[`${k}支内`] = val
        ret[`${k}支外`] = val
        // 浮Aとか
        'ABCDEFGHIJKLM'.split('').forEach(alpha => {
          ret[`${k}${alpha}`] = val
        })
      })
      return ret
    },
    convKiloposts(kps) {
      const roadNameMap = this.getRoadNameShortToRoadNameMap()
      const ignoreMap = this.getRoadNameIgnoreMap()
      const altKpPrefixMap = this.getAltKpPrefixMap()
      const kpByRoadNames = {}
      for (const kp of kps) {
        if (!kp.kp_prefix) { continue }
        if (ignoreMap[kp.kp_prefix]) { continue }
        // 頭の方を取って変換
        let roadNameShort = kp.kp_prefix
        let roadName = roadNameMap[roadNameShort]
        if (!roadName) {
          roadNameShort = altKpPrefixMap[kp.kp_prefix]
          roadName = roadNameMap[roadNameShort]
          if (!roadName) {
            console.error(`convKiloposts. unknown roadName=${roadNameShort} for id=${kp.id}, bikou1=${kp.bikou1}`)
            continue
          }
          // 本線の0km地点以外から数えてるキロポスト.
          // 今は特になんもやってないけど、一応印つけとく.
          kp.is_alt_kp = true
        }

        kp.point = JSON.parse(kp.point)
        if (!kpByRoadNames[roadNameShort]) {
          kpByRoadNames[roadNameShort] = []
        }
        kpByRoadNames[roadNameShort].push(kp)
      }
      return kpByRoadNames
    },
  }
}
